import { HgsArticle } from 'api3';
import { CommonModule } from '@angular/common';
import { Component, ViewEncapsulation, input } from '@angular/core';
import { ImageZoomDirective } from '@app/components/zoom/image-zoom-directive/image-zoom.directive';
import { TranslocoPipe } from '@jsverse/transloco';
import { MarkdownModule } from 'ngx-markdown';

@Component({
  selector: 'app-hgs-renderer',
  template: `
    @if (data() && data()?.text) {
      <div class="pb-24">
        <markdown appImageZoom>{{ data()?.text }}</markdown>
        <p class="hidden">{{ data()?.text | json }}</p>
      </div>
    } @else {
      <p class="mt-8 text-center text-sm text-gray-500">{{ 'global.noOEDataFound' | transloco }}</p>
    }
  `,
  imports: [CommonModule, TranslocoPipe, MarkdownModule, ImageZoomDirective],
  standalone: true,
  encapsulation: ViewEncapsulation.None,
})
export class HgsMarkdownComponent {
  data = input<HgsArticle | undefined>();
}
